import { Button } from 'reactstrap';
import { UnitPcvForm, UnitPcvItemList } from '../models/unitPcv';
import FormModal from '../../../components/modals/FormModal';
import useModalState from '../../../hooks/useModalState';
import ManageUnitPcvForm from './ManageUnitPcvForm';
import { useCallback } from 'react';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import { updatePcvEndpoint } from '../services/unitPcvService';
import { fetchResponseAdapter } from '../../../adapters/fetchAdapter';

interface Props {
  pcv: UnitPcvItemList;
  financesConfig?: boolean;
}

const UnitPcvEditModal = ({ pcv, financesConfig }: Props) => {
  const [isOpenModal, toggleModal] = useModalState();

  const { callEndpoint } = useCallApiAndLoad();
  const navigate = useNavigate();
  const { getAuthToken } = useAuth();
  const token = getAuthToken();

  const auxPcv: UnitPcvForm = {
    area: pcv.area,
    base_price: pcv.base_price,
    bathrooms: pcv.bathrooms,
    bedrooms: pcv.bedrooms,
    initial_base_price: pcv.initial_base_price,
    landlord_id: pcv.landlordInfo?.id ?? null,
    level: pcv.level,
    model_name: pcv.model_name,
    name: pcv.name,
    parking: pcv.parking,
    square_rods: pcv.square_rods,
    unit_amenities: pcv.amenities,
    unit_tags: pcv.tags,
    distribution: pcv.distribution,
    status: pcv.status,
  };

  const handleForm = useCallback(
    async (form: UnitPcvForm, errorRepository: Function) => {
      const { status, data } = await callEndpoint(
        updatePcvEndpoint(pcv.id, form, token),
      );
      const response = fetchResponseAdapter(data);
      if (status === 200) navigate(0);
      else errorRepository(response.message);
    },
    [],
  );

  const editForm = (
    <ManageUnitPcvForm
      unitPcv={auxPcv}
      handleForm={handleForm}
      financesConfig={financesConfig}
    />
  );

  return (
    <>
      <Button color="primary" size="sm" onClick={() => toggleModal()}>
        <i className={'ni ni-ruler-pencil'} /> Editar
      </Button>
      <FormModal
        headerText="Editar PCV"
        children={editForm}
        isOpen={isOpenModal}
        onConfirmation={() => {}}
        onReset={() => {}}
        onToggle={toggleModal}
        size="lg"
        withFooterActions={false}
      />
    </>
  );
};

export default UnitPcvEditModal;
